module.exports = __webpack_public_path__ + "img/engagement_2.f374f3a3.jpg";